export const environment = {
  production: true,
  isSMESite: false,
  ACCTenantId: '177fa145-3580-4afa-a747-bdb81161a871',
  ACCAppId: 'a344bc49-7824-4aa2-9c70-1cbe377a22a9',
  ACCRedirectURI: '/login-callback',
  apiBaseUrl: 'https://rckrqaapi.devaccdata.com',
  ArcGISWebMapId: 'ea5973629e45494f9e97bb2401633f06',
  auth: {
    domain: 'rckr-qa.us.auth0.com',
    clientId: 'it6YpwQHgAnC7QJIimnnPTY7PyDE2iMg',
  },
  appInsightsConnectionString:
    'InstrumentationKey=441546ea-56b0-4e1e-b82a-b040b3692206;IngestionEndpoint=https://centralindia-0.in.applicationinsights.azure.com/;LiveEndpoint=https://centralindia.livediagnostics.monitor.azure.com/;ApplicationId=4afd22f0-50a1-498a-b7b5-ae501e59154d',
  microsoftClarityId: '',
  googleReCaptchaSiteKey: '6LfwEWUrAAAAABEwoPI5JYN0hBnaS8Bk3I3CNLzh',
  crmUrl: 'https://myflowcrm.devaccdata.com',
  showCRMIntegration: false,
  azureConnectionName: 'microsoft-entra',
  auditLogApiUrl:
    'https://fapp-rckr-dh-qa-auditlog-gha8bfbqbmdaangb.centralindia-01.azurewebsites.net',
};
